import { isSafari } from 'components/Result/helper'

const getURLParameters = (url) => {
    let params = {}

    if (isSafari()) {
        // 3.2-10 Safari versions doesn't support URLSearchParams()
        const queryParamsArray = url.split(/&|=/)
        params = extractQueryParams(queryParamsArray)
    } else {
        const urlSearchParams = new URLSearchParams(url)

        for (const [key, value] of urlSearchParams.entries()) {
            params[key] = value
        }
    }

    return params
}

const filterParamsStartingWithUtm = (params) => {
    const utmParams = {}

    for (const key in params) {
        const keyInLowerCase = key.toLowerCase()
        if (keyInLowerCase.startsWith('utm')) {
            utmParams[key] = params[key]
        }
    }

    return utmParams
}

const extractQueryParams = (queryParamsArray) => {
    const params = {}

    for (let i = 0; i < queryParamsArray.length; i += 2) {
        params[queryParamsArray[i]] = queryParamsArray[i + 1]
    }

    return params
}

const getUpdatedUtmParams = () => {
    let utmParams = {}

    // 1. Try to read from current URL search parameters
    if (typeof window !== 'undefined' && window.location && window.location.search) {
        const params = getURLParameters(window.location.search)
        const utmFromUrl = filterParamsStartingWithUtm(params)
        if (Object.keys(utmFromUrl).length > 0) {
            utmParams = utmFromUrl
            // Update storage with the latest URL parameters
            localStorage.setItem('utmParams', JSON.stringify(utmFromUrl))
            sessionStorage.setItem('utmParams', JSON.stringify(utmFromUrl))
        }

        // Also update gclid and fbclid in localStorage if present in URL
        if (params['gclid']) {
            localStorage.setItem('gclid', params['gclid'])
            utmParams['gclid'] = params['gclid']
        }
        if (params['fbclid']) {
            localStorage.setItem('fbclid', params['fbclid'])
            utmParams['fbclid'] = params['fbclid']
        }
    }

    return utmParams
}

export { getURLParameters, filterParamsStartingWithUtm, extractQueryParams, getUpdatedUtmParams }
